<template>
  <span class="account">
    <template v-if="experiments.length > 0">
      <v-toolbar flat>
        <v-toolbar-title class="title">{{ $t("experiments") }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog width="880" v-model="dialog">
          <template v-slot:activator="{ on }">
            <v-btn dark color="indigo accent-4" v-on="on">
              <v-icon left small>{{ mdiFileOutline }}</v-icon
              >{{ $t("add-experiment") }}
            </v-btn>
          </template>
          <AddExperiment
            v-if="dialog == true"
            @attrUpdate="dialog = $event"
            :initialExperiment="experiment"
          />
        </v-dialog>
      </v-toolbar>
      <v-data-table
        @click:row="expandRow"
        :items="experiments"
        :hide-default-footer="experiments.length <= 10"
        :expanded="expanded"
        :headers="headers"
        :sort-desc="true"
        class="elevation-1 ma-4"
        sort-by="id"
        item-key="id"
      >
        <template v-slot:item.date="{ item }">
          {{ $dayjs.unix(item.date).format("DD.MM.YYYY") }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            @click.stop="expandRow(item)"
            class="mr-1"
            height="36"
            color="primary"
            x-small
            text
          >
            <v-icon small class="mr-1">mdi-eye</v-icon> {{ $t("show") }}
          </v-btn>
          <v-btn
            @click.stop="editExperiment(item)"
            class="mr-1"
            height="36"
            color="primary"
            x-small
            text
          >
            <v-icon small class="mr-1">mdi-pencil</v-icon> {{ $t("edit") }}
          </v-btn>
          <v-btn
            @click.stop="deleteExperiment(item.id)"
            height="36"
            color="primary"
            x-small
            text
            ><v-icon small class="mr-1">mdi-delete</v-icon>{{ $t("delete") }}
          </v-btn>
        </template>
        <template v-slot:expanded-item="{ headers }">
          <td :colspan="headers.length" class="px-0">
            <Experiment
              v-if="expanded[0]"
              :experimentId="expanded[0].id"
            ></Experiment>
          </td>
        </template>
      </v-data-table>
    </template>
    <template v-else>
      <AddExperiment class="mt-4" :initialExperiment="{}" />
    </template>
  </span>
</template>

<script>
import { mdiFileOutline } from "@mdi/js";
import AddExperiment from "./AddExperiment";
import Experiment from "./Experiment";
import { has } from "lodash-es";

export default {
  name: "Experiments",
  components: {
    AddExperiment,
    Experiment,
  },
  data: (vm) => ({
    experiment: {},
    dialog: false,
    expanded: [],
    headers: [
      { text: vm.$t("date"), value: "date", width: 200 },
      { text: vm.$t("name"), align: "start", sortable: false, value: "name" },
      {
        text: vm.$t("file"),
        align: "start",
        sortable: false,
        value: "filename",
      },
      {
        text: vm.$t("actions"),
        value: "actions",
        sortable: false,
        width: 360,
      },
    ],
    mdiFileOutline,
  }),
  watch: {
    dialog(value) {
      if (value !== false) return;
      this.experiment = {};
    },
    experiments(value) {
      this.expanded = [value[value.length - 1]];
    },
  },
  computed: {
    experiments() {
      return this.$store.state.account?.current?.experiments || [];
    },
  },
  methods: {
    editExperiment(item) {
      this.experiment = item;
      this.dialog = true;
    },
    deleteExperiment(id) {
      confirm(this.$i18n.t("confirm_delete")) &&
        this.$store.dispatch("experiment/delete", { id });
    },
    expandRow(item) {
      this.expanded = item === this.expanded[0] ? [] : [item];
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep tr:not(.v-data-table__expanded__content) {
  cursor: pointer;
}
</style>
